import styled from "styled-components";

export const TagText = styled.span`
  color: white;
  line-height: ${({ theme }) => theme.lineHeight.big};
`;
